import { makeStyles } from '@mui/styles'

const InProgressPageStyle = makeStyles(() => ({
  icon: {
    fontSize: 70,
    color: '#27ccc6'
  },
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
  },
  container: {
    display: 'inline-block',
    width: '80%',
    '@media all and (min-width: 768px) and (max-width: 959px)': {
      width: '60%'
    },
    '@media all and (min-width: 900px) and (max-width: 960px)': {
      width: '100%'
    },
    '@media all and (max-width: 450px)': {
      width: '100%'
    }
  },
  grid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  typography: {
    fontSize: 25,

    '@media all and (min-width: 480px) and (max-width: 767px)': {
      fontSize: 20
    },
    '@media all and (max-width: 479px)': {
      fontSize: 20
    }
  }
}))

export default InProgressPageStyle
